module.exports = __webpack_public_path__ + "static/img/davis_pictgrid29_980x801.9896c17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid29_980x801.jpg
// module id = 0Ppu
// module chunks = 0